import React, { useEffect } from "react"
import { useTheme } from '~/contexts/ThemeContext'
import { usePlp } from '~/contexts/PlpContext'
import useKeyboardEvent from '~/utils/keyboard-evt'

import { aria_btn, countnum } from "~/styles/app.module.scss"
import * as styles from "~/styles/plp/filters.module.scss"


const Sorts = () => {
  const { isMobile } = useTheme()
  const { products, panelClose, currSort, setCurrSort } = usePlp()

  const { closeListen } = useKeyboardEvent();

  const allPerc = products.find(x => x !== null && x.percent_off) || false
  const allBest = products.find(x => x !== null && x.callouts && x.callouts.find(c => c.name === 'Best Seller') ) || false

  const has_perc = products.find(x => x.percent_off) || false
  const has_best = products.find(x => x.callouts && x.callouts.find(c => c.name === 'Best Seller') ) || false

  const onSort = (type) => {
    setCurrSort(currSort === type ? false : type)
    panelClose()
  }

  const handleClose = () => {
    panelClose()
  }

  useEffect(() => {
    if (!isMobile) closeListen(handleClose)
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <>
      <div className={styles.sort_wr}>
        <div className={[styles.filts_mob, styles.sort_title].join(' ')}>
          Sort<span className={countnum}></span>
        </div>

        <ul className={styles.sorts}>
          <li>
            <button 
              type="button"
              className={`${aria_btn} ${styles.option}`} 
              aria-pressed={currSort === 'asc' ? 'true' : 'false'}
              onClick={(e)=> onSort('asc') }
            >
              <div className={styles.name}>Price Low to High</div>
            </button>
          </li>
          <li>
            <button 
              type="button"
              className={`${aria_btn} ${styles.option}`} 
              aria-pressed={currSort === 'desc' ? 'true' : 'false'}
              onClick={(e)=> onSort('desc') }
            >
              <div className={styles.name}>Price High to Low</div>
            </button>
          </li>
          <li>
            <button 
              type="button"
              className={`${aria_btn} ${styles.option}`} 
              aria-pressed={currSort === 'rec' ? 'true' : 'false'}
              onClick={(e)=> onSort('rec') }
            >
              <div className={styles.name}>Recent</div>
            </button>
          </li>
          {allPerc && (
            <li sort-opt="perc">
              <button 
                type="button"
                className={`${aria_btn} ${styles.option}`} 
                aria-pressed={currSort === 'perc' ? 'true' : 'false'}
                disabled={has_perc ? undefined : 'disabled'}
                onClick={(e)=> onSort('perc') }
              >
                <div className={styles.name}>Percent Off</div>
              </button>
            </li>
          )}
          {allBest && (
            <li>
              <button 
                type="button"
                className={`${aria_btn} ${styles.option}`} 
                aria-pressed={currSort === 'best' ? 'true' : 'false'}
                disabled={has_best ? undefined : 'disabled'}
                onClick={(e)=> onSort('best') }
              >
                <div className={styles.name}>Best Sellers</div>
              </button>
            </li>
          )}
        </ul>
        <div className={`${styles.filts_mob} ${styles.filt_close}`}>
          <button type="button" className={`${aria_btn}`} onClick={(e)=> {handleClose()}}>
            Back to Collection
          </button>
        </div>
      </div>
    </>
  )
};

export default Sorts
